package flagpack.icons

import androidx.compose.ui.graphics.vector.ImageVector
import flagpack.icons.large.Afghanistan
import flagpack.icons.large.AlandIslands
import flagpack.icons.large.Albania
import flagpack.icons.large.Algeria
import flagpack.icons.large.AmericanSamoa
import flagpack.icons.large.Andorra
import flagpack.icons.large.Angola
import flagpack.icons.large.Anguilla
import flagpack.icons.large.Antarctica
import flagpack.icons.large.AntiguaAndBarbuda
import flagpack.icons.large.Argentina
import flagpack.icons.large.Armenia
import flagpack.icons.large.Aruba
import flagpack.icons.large.Australia
import flagpack.icons.large.Austria
import flagpack.icons.large.Azerbaijan
import flagpack.icons.large.Bahamas
import flagpack.icons.large.Bahrain
import flagpack.icons.large.Bangladesh
import flagpack.icons.large.Barbados
import flagpack.icons.large.Belarus
import flagpack.icons.large.Belgium
import flagpack.icons.large.Belize
import flagpack.icons.large.Benin
import flagpack.icons.large.Bermuda
import flagpack.icons.large.Bhutan
import flagpack.icons.large.Bolivia
import flagpack.icons.large.Bonaire
import flagpack.icons.large.BosniaAndHerzegovina
import flagpack.icons.large.Botswana
import flagpack.icons.large.BouvetIsland
import flagpack.icons.large.Brazil
import flagpack.icons.large.BritishIndianOceanTerritory
import flagpack.icons.large.BritishVirginIslands
import flagpack.icons.large.Brunei
import flagpack.icons.large.Bulgaria
import flagpack.icons.large.BurkinaFaso
import flagpack.icons.large.Burundi
import flagpack.icons.large.Cambodia
import flagpack.icons.large.Cameroon
import flagpack.icons.large.Canada
import flagpack.icons.large.CapeVerde
import flagpack.icons.large.CaymanIslands
import flagpack.icons.large.CentralAfricanRepublic
import flagpack.icons.large.Chad
import flagpack.icons.large.Chile
import flagpack.icons.large.China
import flagpack.icons.large.ChristmasIsland
import flagpack.icons.large.CocosIslands
import flagpack.icons.large.Colombia
import flagpack.icons.large.Comoros
import flagpack.icons.large.Congo
import flagpack.icons.large.CookIslands
import flagpack.icons.large.CostaRica
import flagpack.icons.large.CoteDivoire
import flagpack.icons.large.Croatia
import flagpack.icons.large.Cuba
import flagpack.icons.large.Curacao
import flagpack.icons.large.Cyprus
import flagpack.icons.large.CzechRepublic
import flagpack.icons.large.DemocraticRepublicOfCongo
import flagpack.icons.large.Denmark
import flagpack.icons.large.Djibouti
import flagpack.icons.large.Dominica
import flagpack.icons.large.DominicanRepublic
import flagpack.icons.large.Ecuador
import flagpack.icons.large.Egypt
import flagpack.icons.large.ElSalvador
import flagpack.icons.large.EquatorialGuinea
import flagpack.icons.large.Eritrea
import flagpack.icons.large.Estonia
import flagpack.icons.large.Eswatini
import flagpack.icons.large.Ethiopia
import flagpack.icons.large.FalklandIslands
import flagpack.icons.large.FaroeIslands
import flagpack.icons.large.Fiji
import flagpack.icons.large.Finland
import flagpack.icons.large.France
import flagpack.icons.large.FrenchGuiana
import flagpack.icons.large.FrenchPolynesia
import flagpack.icons.large.FrenchSouthernTerritories
import flagpack.icons.large.Gabon
import flagpack.icons.large.Gambia
import flagpack.icons.large.Georgia
import flagpack.icons.large.Germany
import flagpack.icons.large.Ghana
import flagpack.icons.large.Gibraltar
import flagpack.icons.large.Greece
import flagpack.icons.large.Greenland
import flagpack.icons.large.Grenada
import flagpack.icons.large.Guadeloupe
import flagpack.icons.large.Guam
import flagpack.icons.large.Guatemala
import flagpack.icons.large.Guernsey
import flagpack.icons.large.Guinea
import flagpack.icons.large.GuineaBissau
import flagpack.icons.large.Guyana
import flagpack.icons.large.Haiti
import flagpack.icons.large.HeardIslandAndMcdonaldIslands
import flagpack.icons.large.Honduras
import flagpack.icons.large.HongKong
import flagpack.icons.large.Hungary
import flagpack.icons.large.Iceland
import flagpack.icons.large.India
import flagpack.icons.large.Indonesia
import flagpack.icons.large.Iran
import flagpack.icons.large.Iraq
import flagpack.icons.large.Ireland
import flagpack.icons.large.IsleOfMan
import flagpack.icons.large.Israel
import flagpack.icons.large.Italy
import flagpack.icons.large.Jamaica
import flagpack.icons.large.Japan
import flagpack.icons.large.Jersey
import flagpack.icons.large.Jordan
import flagpack.icons.large.Kazakhstan
import flagpack.icons.large.Kenya
import flagpack.icons.large.Kiribati
import flagpack.icons.large.Kuwait
import flagpack.icons.large.Kyrgyzstan
import flagpack.icons.large.Laos
import flagpack.icons.large.Latvia
import flagpack.icons.large.Lebanon
import flagpack.icons.large.Lesotho
import flagpack.icons.large.Liberia
import flagpack.icons.large.Libya
import flagpack.icons.large.Liechtenstein
import flagpack.icons.large.Lithuania
import flagpack.icons.large.Luxembourg
import flagpack.icons.large.Macao
import flagpack.icons.large.Madagascar
import flagpack.icons.large.Malawi
import flagpack.icons.large.Malaysia
import flagpack.icons.large.Maldives
import flagpack.icons.large.Mali
import flagpack.icons.large.Malta
import flagpack.icons.large.MarshallIslands
import flagpack.icons.large.Martinique
import flagpack.icons.large.Mauritania
import flagpack.icons.large.Mauritius
import flagpack.icons.large.Mayotte
import flagpack.icons.large.Mexico
import flagpack.icons.large.Micronesia
import flagpack.icons.large.Moldova
import flagpack.icons.large.Monaco
import flagpack.icons.large.Mongolia
import flagpack.icons.large.Montenegro
import flagpack.icons.large.Montserrat
import flagpack.icons.large.Morocco
import flagpack.icons.large.Mozambique
import flagpack.icons.large.Myanmar
import flagpack.icons.large.Namibia
import flagpack.icons.large.Nauru
import flagpack.icons.large.Nepal
import flagpack.icons.large.Netherlands
import flagpack.icons.large.NewCaledonia
import flagpack.icons.large.NewZealand
import flagpack.icons.large.Nicaragua
import flagpack.icons.large.Niger
import flagpack.icons.large.Nigeria
import flagpack.icons.large.Niue
import flagpack.icons.large.NorfolkIsland
import flagpack.icons.large.NorthKorea
import flagpack.icons.large.NorthMacedonia
import flagpack.icons.large.NorthernIreland
import flagpack.icons.large.NorthernMarianaIslands
import flagpack.icons.large.Norway
import flagpack.icons.large.Oman
import flagpack.icons.large.Pakistan
import flagpack.icons.large.Palau
import flagpack.icons.large.Palestine
import flagpack.icons.large.Panama
import flagpack.icons.large.PapuaNewGuinea
import flagpack.icons.large.Paraguay
import flagpack.icons.large.Peru
import flagpack.icons.large.Philippines
import flagpack.icons.large.PitcairnIslands
import flagpack.icons.large.Poland
import flagpack.icons.large.Portugal
import flagpack.icons.large.PuertoRico
import flagpack.icons.large.Qatar
import flagpack.icons.large.Reunion
import flagpack.icons.large.Romania
import flagpack.icons.large.Russia
import flagpack.icons.large.Rwanda
import flagpack.icons.large.Saba
import flagpack.icons.large.SaintBarthelemy
import flagpack.icons.large.SaintHelena
import flagpack.icons.large.SaintKittsAndNevis
import flagpack.icons.large.SaintLucia
import flagpack.icons.large.SaintMartin
import flagpack.icons.large.SaintPierreAndMiquelon
import flagpack.icons.large.SaintVincentAndTheGrenadines
import flagpack.icons.large.Samoa
import flagpack.icons.large.SanMarino
import flagpack.icons.large.SaoTomeAndPrincipe
import flagpack.icons.large.SaudiArabia
import flagpack.icons.large.Scotland
import flagpack.icons.large.Senegal
import flagpack.icons.large.Serbia
import flagpack.icons.large.Seychelles
import flagpack.icons.large.SierraLeone
import flagpack.icons.large.Singapore
import flagpack.icons.large.SintEustatius
import flagpack.icons.large.SintMaarten
import flagpack.icons.large.Slovakia
import flagpack.icons.large.Slovenia
import flagpack.icons.large.SolomonIslands
import flagpack.icons.large.Somalia
import flagpack.icons.large.SouthAfrica
import flagpack.icons.large.SouthGeorgia
import flagpack.icons.large.SouthKorea
import flagpack.icons.large.SouthSudan
import flagpack.icons.large.Spain
import flagpack.icons.large.SriLanka
import flagpack.icons.large.Sudan
import flagpack.icons.large.Suriname
import flagpack.icons.large.SvalbardAndJanMayen
import flagpack.icons.large.Sweden
import flagpack.icons.large.Switzerland
import flagpack.icons.large.Syria
import flagpack.icons.large.Taiwan
import flagpack.icons.large.Tajikistan
import flagpack.icons.large.Tanzania
import flagpack.icons.large.Thailand
import flagpack.icons.large.TimorLeste
import flagpack.icons.large.Togo
import flagpack.icons.large.Tokelau
import flagpack.icons.large.Tonga
import flagpack.icons.large.TrinidadAndTobago
import flagpack.icons.large.Tunisia
import flagpack.icons.large.Turkey
import flagpack.icons.large.Turkmenistan
import flagpack.icons.large.TurksAndCaicosIslands
import flagpack.icons.large.Tuvalu
import flagpack.icons.large.Uganda
import flagpack.icons.large.Ukraine
import flagpack.icons.large.UnitedArabEmirates
import flagpack.icons.large.UnitedKingdom
import flagpack.icons.large.UnitedStates
import flagpack.icons.large.Uruguay
import flagpack.icons.large.UsMinorOutlyingIslands
import flagpack.icons.large.UsVirginIslands
import flagpack.icons.large.Uzbekistan
import flagpack.icons.large.Vanuatu
import flagpack.icons.large.VaticanCity
import flagpack.icons.large.Venezuela
import flagpack.icons.large.Vietnam
import flagpack.icons.large.Wales
import flagpack.icons.large.WallisAndFutuna
import flagpack.icons.large.WesternSahara
import flagpack.icons.large.Yemen
import flagpack.icons.large.Zambia
import flagpack.icons.large.Zimbabwe

/**
 * List of all Large (32x24dp) flag icons.
 *
 * Contains 254 flags, lazily initialized.
 */
public val FlagIcons.LargeFlagList: List<ImageVector>
    get() {
        if (_largeFlagList != null) {
            return _largeFlagList!!
        }
        _largeFlagList = listOf(
            FlagIcons.Large.Afghanistan,
            FlagIcons.Large.AlandIslands,
            FlagIcons.Large.Albania,
            FlagIcons.Large.Algeria,
            FlagIcons.Large.AmericanSamoa,
            FlagIcons.Large.Andorra,
            FlagIcons.Large.Angola,
            FlagIcons.Large.Anguilla,
            FlagIcons.Large.Antarctica,
            FlagIcons.Large.AntiguaAndBarbuda,
            FlagIcons.Large.Argentina,
            FlagIcons.Large.Armenia,
            FlagIcons.Large.Aruba,
            FlagIcons.Large.Australia,
            FlagIcons.Large.Austria,
            FlagIcons.Large.Azerbaijan,
            FlagIcons.Large.Bahamas,
            FlagIcons.Large.Bahrain,
            FlagIcons.Large.Bangladesh,
            FlagIcons.Large.Barbados,
            FlagIcons.Large.Belarus,
            FlagIcons.Large.Belgium,
            FlagIcons.Large.Belize,
            FlagIcons.Large.Benin,
            FlagIcons.Large.Bermuda,
            FlagIcons.Large.Bhutan,
            FlagIcons.Large.Bolivia,
            FlagIcons.Large.Bonaire,
            FlagIcons.Large.BosniaAndHerzegovina,
            FlagIcons.Large.Botswana,
            FlagIcons.Large.BouvetIsland,
            FlagIcons.Large.Brazil,
            FlagIcons.Large.BritishIndianOceanTerritory,
            FlagIcons.Large.BritishVirginIslands,
            FlagIcons.Large.Brunei,
            FlagIcons.Large.Bulgaria,
            FlagIcons.Large.BurkinaFaso,
            FlagIcons.Large.Burundi,
            FlagIcons.Large.Cambodia,
            FlagIcons.Large.Cameroon,
            FlagIcons.Large.Canada,
            FlagIcons.Large.CapeVerde,
            FlagIcons.Large.CaymanIslands,
            FlagIcons.Large.CentralAfricanRepublic,
            FlagIcons.Large.Chad,
            FlagIcons.Large.Chile,
            FlagIcons.Large.China,
            FlagIcons.Large.ChristmasIsland,
            FlagIcons.Large.CocosIslands,
            FlagIcons.Large.Colombia,
            FlagIcons.Large.Comoros,
            FlagIcons.Large.Congo,
            FlagIcons.Large.CookIslands,
            FlagIcons.Large.CostaRica,
            FlagIcons.Large.CoteDivoire,
            FlagIcons.Large.Croatia,
            FlagIcons.Large.Cuba,
            FlagIcons.Large.Curacao,
            FlagIcons.Large.Cyprus,
            FlagIcons.Large.CzechRepublic,
            FlagIcons.Large.DemocraticRepublicOfCongo,
            FlagIcons.Large.Denmark,
            FlagIcons.Large.Djibouti,
            FlagIcons.Large.Dominica,
            FlagIcons.Large.DominicanRepublic,
            FlagIcons.Large.Ecuador,
            FlagIcons.Large.Egypt,
            FlagIcons.Large.ElSalvador,
            FlagIcons.Large.EquatorialGuinea,
            FlagIcons.Large.Eritrea,
            FlagIcons.Large.Estonia,
            FlagIcons.Large.Eswatini,
            FlagIcons.Large.Ethiopia,
            FlagIcons.Large.FalklandIslands,
            FlagIcons.Large.FaroeIslands,
            FlagIcons.Large.Fiji,
            FlagIcons.Large.Finland,
            FlagIcons.Large.France,
            FlagIcons.Large.FrenchGuiana,
            FlagIcons.Large.FrenchPolynesia,
            FlagIcons.Large.FrenchSouthernTerritories,
            FlagIcons.Large.Gabon,
            FlagIcons.Large.Gambia,
            FlagIcons.Large.Georgia,
            FlagIcons.Large.Germany,
            FlagIcons.Large.Ghana,
            FlagIcons.Large.Gibraltar,
            FlagIcons.Large.Greece,
            FlagIcons.Large.Greenland,
            FlagIcons.Large.Grenada,
            FlagIcons.Large.Guadeloupe,
            FlagIcons.Large.Guam,
            FlagIcons.Large.Guatemala,
            FlagIcons.Large.Guernsey,
            FlagIcons.Large.Guinea,
            FlagIcons.Large.GuineaBissau,
            FlagIcons.Large.Guyana,
            FlagIcons.Large.Haiti,
            FlagIcons.Large.HeardIslandAndMcdonaldIslands,
            FlagIcons.Large.Honduras,
            FlagIcons.Large.HongKong,
            FlagIcons.Large.Hungary,
            FlagIcons.Large.Iceland,
            FlagIcons.Large.India,
            FlagIcons.Large.Indonesia,
            FlagIcons.Large.Iran,
            FlagIcons.Large.Iraq,
            FlagIcons.Large.Ireland,
            FlagIcons.Large.IsleOfMan,
            FlagIcons.Large.Israel,
            FlagIcons.Large.Italy,
            FlagIcons.Large.Jamaica,
            FlagIcons.Large.Japan,
            FlagIcons.Large.Jersey,
            FlagIcons.Large.Jordan,
            FlagIcons.Large.Kazakhstan,
            FlagIcons.Large.Kenya,
            FlagIcons.Large.Kiribati,
            FlagIcons.Large.Kuwait,
            FlagIcons.Large.Kyrgyzstan,
            FlagIcons.Large.Laos,
            FlagIcons.Large.Latvia,
            FlagIcons.Large.Lebanon,
            FlagIcons.Large.Lesotho,
            FlagIcons.Large.Liberia,
            FlagIcons.Large.Libya,
            FlagIcons.Large.Liechtenstein,
            FlagIcons.Large.Lithuania,
            FlagIcons.Large.Luxembourg,
            FlagIcons.Large.Macao,
            FlagIcons.Large.Madagascar,
            FlagIcons.Large.Malawi,
            FlagIcons.Large.Malaysia,
            FlagIcons.Large.Maldives,
            FlagIcons.Large.Mali,
            FlagIcons.Large.Malta,
            FlagIcons.Large.MarshallIslands,
            FlagIcons.Large.Martinique,
            FlagIcons.Large.Mauritania,
            FlagIcons.Large.Mauritius,
            FlagIcons.Large.Mayotte,
            FlagIcons.Large.Mexico,
            FlagIcons.Large.Micronesia,
            FlagIcons.Large.Moldova,
            FlagIcons.Large.Monaco,
            FlagIcons.Large.Mongolia,
            FlagIcons.Large.Montenegro,
            FlagIcons.Large.Montserrat,
            FlagIcons.Large.Morocco,
            FlagIcons.Large.Mozambique,
            FlagIcons.Large.Myanmar,
            FlagIcons.Large.Namibia,
            FlagIcons.Large.Nauru,
            FlagIcons.Large.Nepal,
            FlagIcons.Large.Netherlands,
            FlagIcons.Large.NewCaledonia,
            FlagIcons.Large.NewZealand,
            FlagIcons.Large.Nicaragua,
            FlagIcons.Large.Niger,
            FlagIcons.Large.Nigeria,
            FlagIcons.Large.Niue,
            FlagIcons.Large.NorfolkIsland,
            FlagIcons.Large.NorthKorea,
            FlagIcons.Large.NorthMacedonia,
            FlagIcons.Large.NorthernIreland,
            FlagIcons.Large.NorthernMarianaIslands,
            FlagIcons.Large.Norway,
            FlagIcons.Large.Oman,
            FlagIcons.Large.Pakistan,
            FlagIcons.Large.Palau,
            FlagIcons.Large.Palestine,
            FlagIcons.Large.Panama,
            FlagIcons.Large.PapuaNewGuinea,
            FlagIcons.Large.Paraguay,
            FlagIcons.Large.Peru,
            FlagIcons.Large.Philippines,
            FlagIcons.Large.PitcairnIslands,
            FlagIcons.Large.Poland,
            FlagIcons.Large.Portugal,
            FlagIcons.Large.PuertoRico,
            FlagIcons.Large.Qatar,
            FlagIcons.Large.Reunion,
            FlagIcons.Large.Romania,
            FlagIcons.Large.Russia,
            FlagIcons.Large.Rwanda,
            FlagIcons.Large.Saba,
            FlagIcons.Large.SaintBarthelemy,
            FlagIcons.Large.SaintHelena,
            FlagIcons.Large.SaintKittsAndNevis,
            FlagIcons.Large.SaintLucia,
            FlagIcons.Large.SaintMartin,
            FlagIcons.Large.SaintPierreAndMiquelon,
            FlagIcons.Large.SaintVincentAndTheGrenadines,
            FlagIcons.Large.Samoa,
            FlagIcons.Large.SanMarino,
            FlagIcons.Large.SaoTomeAndPrincipe,
            FlagIcons.Large.SaudiArabia,
            FlagIcons.Large.Scotland,
            FlagIcons.Large.Senegal,
            FlagIcons.Large.Serbia,
            FlagIcons.Large.Seychelles,
            FlagIcons.Large.SierraLeone,
            FlagIcons.Large.Singapore,
            FlagIcons.Large.SintEustatius,
            FlagIcons.Large.SintMaarten,
            FlagIcons.Large.Slovakia,
            FlagIcons.Large.Slovenia,
            FlagIcons.Large.SolomonIslands,
            FlagIcons.Large.Somalia,
            FlagIcons.Large.SouthAfrica,
            FlagIcons.Large.SouthGeorgia,
            FlagIcons.Large.SouthKorea,
            FlagIcons.Large.SouthSudan,
            FlagIcons.Large.Spain,
            FlagIcons.Large.SriLanka,
            FlagIcons.Large.Sudan,
            FlagIcons.Large.Suriname,
            FlagIcons.Large.SvalbardAndJanMayen,
            FlagIcons.Large.Sweden,
            FlagIcons.Large.Switzerland,
            FlagIcons.Large.Syria,
            FlagIcons.Large.Taiwan,
            FlagIcons.Large.Tajikistan,
            FlagIcons.Large.Tanzania,
            FlagIcons.Large.Thailand,
            FlagIcons.Large.TimorLeste,
            FlagIcons.Large.Togo,
            FlagIcons.Large.Tokelau,
            FlagIcons.Large.Tonga,
            FlagIcons.Large.TrinidadAndTobago,
            FlagIcons.Large.Tunisia,
            FlagIcons.Large.Turkey,
            FlagIcons.Large.Turkmenistan,
            FlagIcons.Large.TurksAndCaicosIslands,
            FlagIcons.Large.Tuvalu,
            FlagIcons.Large.Uganda,
            FlagIcons.Large.Ukraine,
            FlagIcons.Large.UnitedArabEmirates,
            FlagIcons.Large.UnitedKingdom,
            FlagIcons.Large.UnitedStates,
            FlagIcons.Large.Uruguay,
            FlagIcons.Large.UsMinorOutlyingIslands,
            FlagIcons.Large.UsVirginIslands,
            FlagIcons.Large.Uzbekistan,
            FlagIcons.Large.Vanuatu,
            FlagIcons.Large.VaticanCity,
            FlagIcons.Large.Venezuela,
            FlagIcons.Large.Vietnam,
            FlagIcons.Large.Wales,
            FlagIcons.Large.WallisAndFutuna,
            FlagIcons.Large.WesternSahara,
            FlagIcons.Large.Yemen,
            FlagIcons.Large.Zambia,
            FlagIcons.Large.Zimbabwe
        )
        return _largeFlagList!!
    }

@Suppress("ObjectPropertyName")
private var _largeFlagList: List<ImageVector>? = null
